// extracted by mini-css-extract-plugin
export default {"root":"ImageFromFile_root__A3E2O","aspectWrapper":"ImageFromFile_aspectWrapper__-5BrC","rootForImage":"ImageFromFile_rootForImage__2a6Ur"};